import React, { useState, useEffect } from "react";
import Tab from "../components/tab";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import { Typewriter } from "react-simple-typewriter";
import ResumeFormat from "../../Resume/resume_format/resume_format";
import { useNavigate } from "react-router-dom/dist";
import { useSelector, useDispatch } from "react-redux";
import HelmetProvide from "../../common/helmet";
import { 
  saveCvDetails, 
  ClickLoading,
  currentEducation_loading,
  currentExperience_loading,
  current_skills_loading,
  ActivitiesDetails_loading,
  personal_loading,
  p_skillsDetails_loading,
  skillsDetails_loading,
  EducationDetails_loading,
  clearPS,
  LanguageTranslate_loading,
  cert_loading,
  yof_loading,
  SiteErrorLoading
} from "../../../Redux/ActionCreator"
import { v4 as uuidv4 } from "uuid";
import LoaderModal from "../../common/LoaderModal"
import InterviewModal from "../../common/interviewModal"
import DownloadResumeModal from "../../Resume/DownloadResume"
import { getOneFromServerCache, deleteMultipleKey } from "../../../utils/saveIntoCache";
import { ToastContainer, toast } from 'react-toastify';

let obj = [
  {
    format: 'https://res.cloudinary.com/drlcisipo/image/upload/v1707771214/Resume%20assets/resume_acjg0i.png',
    id: 1,
    name: `Golden Resume`,
  },
  {
    format: 'https://res.cloudinary.com/drlcisipo/image/upload/v1707771214/Resume%20assets/sample_bphs7a.png',
    id: 2,
    name: `sample`,
  },
  {
    format: 'https://res.cloudinary.com/drlcisipo/image/upload/v1719985893/minimal_e1k8m3.jpg',
    id: 3,
    name: `Black minimal`,
  },
]

const SelcectTemplate = ({ prevStep, nextStep }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const saved_cv_details = useSelector((prev) => prev.saved_cv);
  const profile = useSelector(e => e.profile.message);
  const userInfo = useSelector((e) => e.userInfo);
  const [ saveResume, setSaveResume ] = useState(false);
  const clickStat = useSelector(e => e.click);
  const generated_cv = useSelector(e => e.generateCV.message);
  const [ loading, setLoading ] = useState(false);

  const [showHeading1, setShowHeading1] = useState(false);
  const [showHeading2, setShowHeading2] = useState(false);
  const [showHeading3, setShowHeading3] = useState(false);

  let download = true; // manual for now.
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const [ language, setLanguage ] = useState("English");
  const sidebar = useSelector(e => e.sidebarOpen.message);

  const queryParam = new URLSearchParams(window.location.search);
  let d_download = queryParam.get("download");
  let lg = queryParam.get("lg");
  console.log("d_download", d_download);
  useEffect(() => {
    if (download !== null) {
      let Language = getOneFromServerCache("Language");
      Language.then(resp => resp.json())
        .then(resp => {
          // console.log("Language", resp.data);
          if (resp.success == true) {
            if (resp.data == null) {
              // setLanguage(JSON.parse(resp.data));
            } else {
              setLanguage(JSON.parse(resp.data));
            }
          } else if (resp.success === false && resp.message == "Unauthorized") {
            dispatch(returnHome(resp.status));
          }
        }).catch(err => {
          // console.log("Language getting error", err);
        });
    }
  }, []);


  useEffect(() => {
    // let get the last resume aws_link and download it
    let lastCv = saved_cv_details?.message[saved_cv_details?.message?.length - 1];
    let lastCvId = lastCv?.pdfId;
    // console.log("Last cv Id", lastCvId);
    if (clickStat.message == true) {
      if (parseInt(lastCvId, 10) < 6 && lastCv?.aws_link !== undefined) {
        // then perform the download here.
        downloadFile(lastCv)
      } else {
        setSaveResume(false);
        dispatch(ClickLoading(true));
      }
    }

  }, [saved_cv_details.message]);

  const error = useSelector(e => e.errors);
  useEffect(() => {
    // let get the last resume aws_link and download it
    if (error.errMess !== null) {
      setTimeout(() => {
        toast.error(error.errMess, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
      setLoading(false);
      dispatch(SiteErrorLoading())
    }

  }, [error]);

  const downloadFile = async (lastCv) => {
    const fileUrl = lastCv?.aws_link;
    let link = document.createElement('a');
    link.href = fileUrl;
    link.download = lastCv?.CvType;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setSaveResume(false);
    dispatch(ClickLoading(true));
    clearAllresumeInfoBothWithinStoreAndCache();
    navigate(`/user/profile/:${userInfo.user.profile_id}`);
  }

  const clearAllresumeInfoBothWithinStoreAndCache = async () => {
    try {
      dispatch(currentEducation_loading()),
      dispatch(currentExperience_loading()),
      dispatch(current_skills_loading()),
      dispatch(ActivitiesDetails_loading()),
      dispatch(personal_loading()),
      dispatch(p_skillsDetails_loading()),
      dispatch(skillsDetails_loading()),
      dispatch(EducationDetails_loading()),
      dispatch(clearPS());
      dispatch(cert_loading());
      dispatch(yof_loading());

      // then delete them from cache
      let keysToGet = [
        "step",
        "personalInfo", 
        "current_experience", 
        "experience", 
        "current_skills", 
        "technicalSkills", 
        "personalSkills", 
        "education", 
        "current_education", 
        "language", 
        "summary",
        "cert"
      ];
      await deleteMultipleKey(keysToGet);
    } catch (error) {
      console.log("Error returning resume information back to initial state", error);
    }
  }

  useEffect(() => {
    const showHeading1Timeout = setTimeout(() => setShowHeading1(true), 1500);
    return () => clearTimeout(showHeading1Timeout);
  }, []);

  useEffect(() => {
    if (showHeading1) {
      const showHeading2Timeout = setTimeout(() => setShowHeading2(true), 2500);
      return () => clearTimeout(showHeading2Timeout);
    }
  }, [showHeading1]);

  useEffect(() => {
    if (showHeading2) {
      const showHeading3Timeout = setTimeout(() => setShowHeading3(true), 2500);
      return () => clearTimeout(showHeading3Timeout);
    }
  }, [showHeading2]);
  
  let [ cv_details, setCv_details ] = useState();

  // console.log("generated_cv", generated_cv);
  const handleSelection = (data) => {
    if (download) {
      // setCv_details(cv_details)
      const clientSecret = uuidv4();
      let Secret = clientSecret;
      // after selecting here, show the loadmodal till the resume is fully downloaded, after which you redirect back to home page.
      let details
      if (generated_cv !== null && generated_cv !== undefined) {
        details = {
          Fullname: generated_cv.Fullname,
          Email: generated_cv.Email,
          Phone_number: generated_cv.Phone_number,
          Address: generated_cv.Address,
          Professional_summary: generated_cv.Professional_summary,
          Education: generated_cv.Education,
          Experience: generated_cv.Experience,
          Technical_skills: generated_cv.Technical_skills,
          Personal_skills: generated_cv.Personal_skills, 
          Reference: generated_cv.Reference || [],
          CvType: generated_cv.CvType,
          Language: generated_cv.Language,
          Lang: [{lang: lg !== null ? lg: flowLanguage}],
          Award: [],
          year_of_experience: generated_cv.year_of_experience,
          pdfId: data.id,
          certification: generated_cv.certification,
          JobInterests: generated_cv.JobInterests,
          EnglishTitle: generated_cv?.EnglishTitle !== undefined ? generated_cv?.EnglishTitle : profile?.Job_type,
        }
      } else {
        details = {
          Fullname: profile.FirstName + " " + profile.LastName,
          FirstName: profile.FirstName,
          LastName: profile.LastName,
          Email: profile.Email,
          Phone_number: profile.Phone_number,
          Address: profile.Address,
          Professional_summary: profile.About,
          Education: profile.Education,
          Experience: profile.Experience,
          Technical_skills: profile.Skills,
          Personal_skills: profile.Soft_skills, 
          Reference: profile.Reference || [],
          CvType: profile.Job_type,
          Language: profile.Language,
          Lang: [{lang: lg !== null ? lg: flowLanguage}],
          Award: [],
          year_of_experience: profile.year_of_experience,
          pdfId: data.id,
          certification: profile.certification,
          JobInterests: profile.JobInterests,
          EnglishTitle: profile.Job_type,
        }
      }
      // console.log("pdfid", data.id);
      if (data.id >= 6) {
        setCv_details({...details, Secret: Secret});
        setShow(true);
      } else {
        setLoading(true);
        setSaveResume(true);
        let text = "Translated Already";
        if (generated_cv !== null && generated_cv !== undefined && d_download == null) {
          text = "Not translated yet";
        }
        dispatch(saveCvDetails(details, data.id, Secret, language, text ));
        // dispatch(LanguageTranslate_loading());
      }
      // navigate("/download");
    } else {
      navigate(`/form/${data?.id}/${data?.name}?template=true`);
    }
  }

  return (
    <>
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-screen flex justify-center lg:items-center">
      <div className="max-w-[100vw] w-full gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md">
        {/* Tabs Section */}
        <div className="flex justify-center w-full">
          <div className="tabarea gap-x-0 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="3" current={false} label="Skills" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="4" current={false} label="Language" completed={true} />
            </div>
            <Tab num="5" current={false} label="Education" completed={true} />
            <Tab num="6" current={false} label="Professional Summary" completed={true} />
          </div>
        </div>

        <div className="text-center">
          <div className="flex justify-center">
            <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1740122607/Website%20images/congrat-icon_nruhca.png" alt="Party Popper" className="w-16 h-16 mb-4" />
          </div>
          <h2 className="text-3xl font-extrabold tracking-tight text-[#5843BD] sm:text-4xl notranslate">
            {flowLanguage == "Spanish" ? (
              <Typewriter key={flowLanguage} words={["¡Tu currículum está listo!"]} loop={1} typeSpeed={40} />
            ) : (
              <Typewriter key={flowLanguage} words={["Your resume is now ready!"]} loop={1} typeSpeed={40} />
            )}
            {/* <Typewriter words={["Your profile is now ready!"]} loop={1} typeSpeed={40} /> */}
          </h2>

          {showHeading1 && (
            <p className="mt-4 text-lg leading-6 text-gray-500 notranslate">
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["Ahora selecciona una plantilla y crearemos tu currículum automáticamente."]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Now select a template and we will automatically create your resume for you. Click on any of the templates below to start."]} loop={1} typeSpeed={40} />
              )}
              {/* <Typewriter words={["Now select a template and we will automatically create your resume for you. Click on any of the templates below to start."]} loop={1} typeSpeed={40} /> */}
            </p>
          )}
        </div>

        {showHeading2 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {obj.map((element, key) => (
              <div className="bg-white shadow-md rounded-lg overflow-hidden" key={key} onClick={() => handleSelection(element)}>
                {/* <img src='https://res.cloudinary.com/drlcisipo/image/upload/v1707771214/Resume%20assets/sample_bphs7a.png' alt="`sample" className="w-full" /> */}
                <ResumeFormat format={element.format} name={element.name}  />
              </div>
            ))}
          </motion.div>
        )}

        {/* {showHeading3 && (
          <div className="my-10 text-center">
            <p className="text-lg leading-6 text-gray-500 notranslate">
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["Haz clic en Descargar para descargar e imprimir tu currículum."]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Click on download to download and print your resume."]} loop={1} typeSpeed={40} />
              )}
            </p>
          </div>
        )} */}
        
        {/* Navigation Buttons */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8, ease: "easeOut", delay: 6.8 }} 
        >
          <Footer nextStep={nextStep} prevStep={prevStep} showNext={false} />
        </motion.div>
      </div>
    </div>
    { loading && <LoaderModal text="Processing your information" />}
    <ToastContainer />
    </>
  );
};

export default SelcectTemplate;
